export function getMarkdown(input: Record<string, any> | string[]): string {
  // Handle array of strings directly
  if (Array.isArray(input)) {
    return input.map((item: string) => `- ${item}`).join('\n');
  }

  // Handle object as before
  return Object.entries(input)
    .map(([key, value]) => {
      // Handle array values
      if (Array.isArray(value)) {
        const subItems = value.map((item: string) => `\t- ${item}`).join('\n');
        return `- ${key}\n${subItems}`;
      }
      // Handle single value
      return `- ${key}\n\t- ${String(value)}`;
    })
    .join('\n');
}
